module.exports = __webpack_public_path__ + "static/media/cover-fallback@2x.cfa68b34.webp";